module.exports = __webpack_public_path__ + "images/img-2pj0uXH.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/managers/94.jpg
// module id = 2018
// module chunks = 0